import type { MarketMemberEntry } from '../types'

const members: MarketMemberEntry[] = [
  {
    img: '/partners/logo_gpm_x300.png',
    company: 'GPM',
    employees: [
      {
        name: 'Carlos Ladero',
        email: 'cladero@gpmbroker.com',
        city: {
          en: 'Madrid',
          es: 'Madrid',
        },
        rol: {
          en: 'Sales Manager',
          es: 'Director Comercial',
        },
        department: [
          {
            en: 'Debt & Equity Capital Markets, Market Member',
            es: 'Mercados de Capitales de Deuda y Renta Variable, Miembro de Mercado',
          },
        ],
        profile: {
          en: 'https://www.linkedin.com/in/carlosladero/',
          es: 'https://www.linkedin.com/in/carlosladero/',
        },
      },
    ],
  },
]

export default members
